import { faSync } from '@fortawesome/pro-light-svg-icons'
import { RectangularInput, RectangularInputFormatNumberSmall } from '../../../../../../../../forms/Input'
import { Modify } from '../../../../../../../../utils/globals/types'
import useSpecificPricesProduct, { SpecificRulesProductExtended } from '../../../../../../../../utils/hooks/product/useSpecificPriceProduct'
import useTwinTranslation from '../../../../../../../../utils/hooks/useTwinTranslation'
import { ComponentWithPermissions } from '../../../../../../../../baseComponents/CreateRoutering/types'
import { ButtonsModalSmallCentered, ModalExtraBig, ModalSmallCentered } from '../../../../../../../../baseComponents/Modal'
import { ModalEditComponentProps } from '../../../../../../../../baseComponents/ModalsLayouts/types'
import { permissionCheck } from '../../../../../../../../baseComponents/PermissionChecker/function'
import TwinIcon from '../../../../../../../../baseComponents/TwinIcon'
import { TitleMButtonPermissioned } from '../../../../../../../../baseComponents/Layout/TitleAndRightLayout'
import { useCallback, useEffect, useState } from 'react'
import { twinFetchPostJSON } from '../../../../../../../../utils/globals/data'
import { ModalOpenedSetTy, ModalOpenedTy } from '../../../../../../../../baseComponents/Modal/types'
import TwinTrans from '../../../../../../../../baseComponents/TwinTrans'
import { SpecificRulesProduct } from '@teinor/erp/prices/types'
import { configurePrice } from '../../../../../../../../utils/globals/price'
import { TwinDictionary } from '../../../../../../../../utils/globals/dictionary'
import { prepareFormatedMeasureQuantity } from '../../../../../../../../utils/globals/product'
import { replaceDotsForDecimalSeparator } from '../../../../../../../../utils/globals/numbers'
import DisplayPrice from '../../../../../../../../baseComponents/Displays/DisplayPrice'
import ITHeaderText from '../../../../../../../../baseComponents/TwinTable/InputTableLayout/InputTableLeftColumn/Components/ITHeaderText'
import { RowData } from '../../../../../../../../baseComponents/TwinTable/types'
import VirtualTableListing from '../../../../../../../../baseComponents/TwinTable/VirtualTableListing'
import { CustomRenderString, CustomRenderBoolean } from '../../../../../../../../baseComponents/TwinTable/VirtualTableListing/CustomRenders'
import { ColumnTableSchema } from '../../../../../../../../baseComponents/TwinTable/VirtualTableListing/Subcomponents/types'
import { displayUnitsIcon, pricesRowRender } from '../../../../../../../Price/DisplayPrice'
import withLoading from '../../../../../../../../utils/hoc/withLoading'
import { connect, ConnectedProps } from 'react-redux'
import { SpecificPriceRulesPayload } from '../../../../../../../../utils/reducers/products/specificPriceRules'
import { AllReduxPayloads } from '../../../../../../../../utils/reducers'
import { CalculateParamsTy } from '../../../../../../../../baseComponents/Displays/DisplayPrice/types'
import { getPreparePricesConfigParam } from '../../../../../../../../utils/reducers/getters'
type ModalPriceProductOrderProps = Modify<ModalEditComponentProps & ComponentWithPermissions & ReduxModalPriceProductOrder & ModalPriceProductOrderLogicProps, {
    headerData: TwinDictionary
}>

const ModalPriceProductOrder: React.FC<ModalPriceProductOrderProps> = ({ allRowData, userPermissions, setOpened, headerData, specificPriceRules }) => {
    const {t} = useTwinTranslation()
    const basicData: any = {id: allRowData?.ProductId}
    const { data, changePrice, saveData, syncWithParent, changeUnits, addUnits, deleteUnits } = useSpecificPricesProduct({ ProductId: basicData.id })
    const { currentStock, setModalSave, modalSave, handleModalSave, saveDataAndCloseModal } = useModalPriceProductOrderLogic({ allRowData, saveData })
    const finalUnitPriceCostWithoutTax = allRowData?.finalUnitPriceCostWithoutTax || allRowData?.finalUnitPriceWithoutTax
    const additionalCost = finalUnitPriceCostWithoutTax - allRowData?.finalUnitPriceWithoutTax
    const calculateParamsDefault = getPreparePricesConfigParam() as CalculateParamsTy
    const columns: ColumnTableSchema<SpecificRulesProductExtended> = [
        {
            id: 'id',
            dataKey: 'id',
            label: t('id', 'ID'),
            customRender: (parameterValue) => <CustomRenderString value={'T'+parameterValue} />,
            minWidth: 20,
        },
        {
            id: 'name',
            dataKey: 'name',
            label: t('name', 'Nombre'),
            minWidth: 150
        },
        {
            id: 'units',
            dataKey: 'units',
            label: t('units', 'Unidades'),
            customRender: (parameterValue, allRowData) => <RectangularInputFormatNumberSmall value={parameterValue ?? 1} readOnly={!permissionCheck(userPermissions, 'update')} onChange={(value) => changeUnits(value, allRowData.absoluteIndex || allRowData.rowIndex)} />,
            minWidth: 100,
        },
        {
            id: 'is_pack',
            dataKey: 'is_pack',
            label: t('pack', 'Pack'),
            customRender: (parameterValue) =><CustomRenderBoolean value={String(parameterValue) === 'true'} />,
            minWidth: 50,
        },
        {
            id: 'price',
            dataKey: 'price',
            label: t('priceOrFormula', 'Precio o formula'),
            customRender: (parameterValue, allRowData) => <RectangularInput value={replaceDotsForDecimalSeparator(parameterValue ?? allRowData.formula ?? '')} readOnly={!permissionCheck(userPermissions, 'update')} onChange={(value) => changePrice(value, allRowData.absoluteIndex || allRowData.rowIndex)} />,
            minWidth: 180
        },
        {
            id: 'calculated_price',
            dataKey: 'calculated_price',
            label: t('newPrice', 'Precio nuevo'),
            customRender: (parameterValue, allRowData) => <DisplayPrice value={parseFloat(parameterValue)} CurrencyId={specificPriceRules?.dictionary[allRowData.SpecificPriceRuleId]?.CurrencyId || 'EUR'} with_vat={false} calculateParams={{
            decimals: allRowData?.decimals,
            rounding: allRowData?.rounding,
            roundingPriceType: calculateParamsDefault?.roundingPriceType
            }} />,
            minWidth: 180
        },
        {
            id: 'oldPrice',
            dataKey: '_old_price',
            label: t('lastPrice', 'Precio anterior'),
            customRender: (parameterValue, allRowData) => <DisplayPrice value={parseFloat(parameterValue)} CurrencyId={specificPriceRules?.dictionary[allRowData.SpecificPriceRuleId]?.CurrencyId || 'EUR'} with_vat={false} calculateParams={{
                decimals: allRowData?.decimals,
                rounding: allRowData?.rounding,
                roundingPriceType: calculateParamsDefault?.roundingPriceType
            }} />,
            minWidth: 180
        },
        {
            id: 'sync',
            dataKey: 'id',
            label: '',
            customRender: (_parameterValue, allRowData) => <TwinIcon icon={faSync} onClick={() => syncWithParent(allRowData)} className={allRowData.price === null ? 'text-green-21' : 'text-red-BA'} />,
            havePermission: permissionCheck(userPermissions, 'update'),
            minWidth: 40
        },
        {
            id: 'delete',
            dataKey: 'id',
            label: '',
            customRender: (_parameterValue, allRowData) => displayUnitsIcon(allRowData, addUnits, deleteUnits),
            havePermission: permissionCheck(userPermissions, 'update'),
            minWidth: 40
        }, 
        {
            id: 'delete',
            dataKey: 'id',
            label: '',
            customRender: (_parameterValue, allRowData) => displayUnitsIcon(allRowData, addUnits, deleteUnits),
            havePermission: permissionCheck(userPermissions, 'update'),
            minWidth: 40
        }
    ]
    return (
        <ModalExtraBig className='h-full flex flex-col' opened={true} setOpened={setOpened} onClickOut={false}>
            <TitleMButtonPermissioned title={t('productPrice', 'Precios del producto') + ': ' + allRowData?.reference + ' - ' + allRowData?.name} buttonText={t('save', 'Guardar')} onClick={handleModalSave} userPermissions={userPermissions} permission='update'>
                <div className='flex justify-between mb-20 w-3/4'>
                    <ITHeaderText label={t('cost', 'Coste')} value={configurePrice(allRowData?.finalUnitPriceWithoutTax || 0, headerData?.CurrencyId)} />
                    <ITHeaderText label={t('additionalCost', 'Coste adicional')} value={configurePrice(additionalCost || 0, headerData?.CurrencyId)} />
                    <ITHeaderText label={t('totalCost', 'Coste Total')} value={configurePrice(finalUnitPriceCostWithoutTax, headerData?.CurrencyId)} />
                    <ITHeaderText label={t('actualStock', 'Stock actual')} value={prepareFormatedMeasureQuantity(parseFloat(currentStock || '0'), allRowData?.['Product.unitMeasure'], allRowData?.['Product.controlUnitType'], t('u', 'u'))} />
                   <ITHeaderText label={t('newStock', 'Stock entrante')} value={prepareFormatedMeasureQuantity(allRowData?.quantity, allRowData?.['Product.unitMeasure'], allRowData?.['Product.controlUnitType'], t('u', 'u'))} /> 
                </div>
                <div className='flex-auto'>
                    <VirtualTableListing tableData={data} columns={columns} rowRenderer={pricesRowRender} name='modalPriceProductOrder'/>
                </div>
            </TitleMButtonPermissioned>
            <ModalConfirmSavePrices  {...{modalSave, setModalSave, data, saveDataAndCloseModal}}/>
        </ModalExtraBig>
    )
}

interface ModalPriceProductOrderLogicProps {
    saveData: (data: SpecificRulesProduct[] | null, ProductId?: string | undefined) => Promise<void>
    allRowData?: RowData
}

const useModalPriceProductOrderLogic = ({ allRowData, saveData }: ModalPriceProductOrderLogicProps) => {
    const [modalSave, setModalSave] = useState<ModalOpenedTy>(null)
    const [currentStock, setCurrentStock] = useState<string | null>(null)

    const getActualStock = useCallback(async () => {
        const result = await twinFetchPostJSON('/api/app/product/stock/getLastStockHistoriesOfStockParentId', { where: { StockParentId: allRowData?.ProductId } })
        if(result && result.length){
            setCurrentStock(result[0].currentStock)
        }
    }, [allRowData])

    const handleModalSave = useCallback(() => {
        setModalSave((old)=>{if(!old){ return true} return null})
    }, [setModalSave])

    const saveDataAndCloseModal = useCallback(async (data: SpecificRulesProductExtended[]| null) => {
        await saveData(data, allRowData?.ProductId)
        handleModalSave()
    }, [handleModalSave, allRowData, saveData])

    useEffect(() => {
        if(!currentStock){
            getActualStock()
        }
    }, [currentStock, getActualStock])
    
    return { currentStock, setModalSave, modalSave, handleModalSave, saveDataAndCloseModal}
}

const modalPriceProductOrderDispatch = {
    setSpecificPriceRules: (payload: SpecificPriceRulesPayload) => ({ type: 'CHANGE_SPECIFICPRICERULES', payload }),
}

type ReduxModalPriceProductOrder = ConnectedProps<typeof modalPriceProductOrderConnect>
const mapModalPriceProductOrderConnector = (state: AllReduxPayloads) => ({ specificPriceRules: state.specificPriceRules })
const modalPriceProductOrderConnect = connect(mapModalPriceProductOrderConnector, modalPriceProductOrderDispatch)

const materialsConnectLoading = withLoading(ModalPriceProductOrder, [{ fetchUrl: '/api/app/product/specificPrice/getAllSpecificPriceRules', propName: 'specificPriceRules', setFunctionName: 'setSpecificPriceRules' }])
const ModalPriceProductOrderConnect = modalPriceProductOrderConnect(materialsConnectLoading)

interface ModalConfirmSavePricesProps { 
    modalSave: ModalOpenedTy 
    setModalSave: ModalOpenedSetTy
    saveDataAndCloseModal: (data: SpecificRulesProductExtended[] | null) => Promise<void>
    data: SpecificRulesProductExtended[] | null
}

const ModalConfirmSavePrices: React.FC<ModalConfirmSavePricesProps> = ({ modalSave, setModalSave, saveDataAndCloseModal, data }) => {
    const {t} = useTwinTranslation()
    return (
        <ModalSmallCentered opened={modalSave} setOpened={setModalSave} onClickOut={false}>
            <div>
                <h2 className='mb-10 inline-block'>
                    <TwinTrans transKey='changeProductPrice'>Cambiar precio de producto</TwinTrans>
                </h2>
                <p className='my-30'>
                    <TwinTrans transKey='allPricesWillBeChanged'>Si confirmas los cambios, todos los precios de este producto se cambiarán</TwinTrans>
                </p>
            </div>
            <ButtonsModalSmallCentered confirmText={t('save', 'Guardar')} setOpened={setModalSave} onCancel={() => setModalSave(null)} onAccept={() => saveDataAndCloseModal(data)} />
        </ModalSmallCentered>
    )
}

export default ModalPriceProductOrderConnect